import { createSlice } from "@reduxjs/toolkit";
import { fetchGroupsList, createOrUpdateGroup, deleteGroup } from "./groupThunks";

const groupSlice = createSlice({
  name: "groups",
  initialState: {
    groups: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedGroup: null,
    isEditGroup: false,
  },
  reducers: {
    resetGroupManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload;
    },
    setIsEditGroup: (state, action) => {
      state.isEditGroup = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGroupsList.fulfilled, (state, action) => {
        state.loading = false;
        state.groups = action.payload;
      })
      .addCase(createOrUpdateGroup.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteGroup.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { resetGroupManageStatus, setSelectedGroup, setIsEditGroup } = groupSlice.actions;
export default groupSlice.reducer;
